import { ActivityCouponState } from '@tencent/wphk-act-base-types';
export { ActivityCouponState };
/**
 * 连锁活动券状态
 */
export var ChainDisplayCouponState;
(function (ChainDisplayCouponState) {
    /** 未领取 */
    ChainDisplayCouponState["notReceived"] = "notReceived";
    /** 已领取 */
    ChainDisplayCouponState["received"] = "received";
    /** 已使用 */
    ChainDisplayCouponState["used"] = "used";
    /** 已过期 */
    ChainDisplayCouponState["expired"] = "expired";
    /** 未解锁状态，连锁券常用 */
    ChainDisplayCouponState["locked"] = "locked";
    /** 已领取，但未可用 */
    ChainDisplayCouponState["noCanUse"] = "noCanUse";
    /** 奖品维度-今日已领完 */
    ChainDisplayCouponState["dayLimit"] = "dayLimit";
    /** 奖品维度-券已售罄 */
    ChainDisplayCouponState["totalLimit"] = "totalLimit";
})(ChainDisplayCouponState || (ChainDisplayCouponState = {}));
